"use strict";
var RangeObservable_1 = require('./RangeObservable');
exports.range = RangeObservable_1.RangeObservable.create;
//# sourceMappingURL=range.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/observable/range.js
// module id = ../../../../rxjs/observable/range.js
// module chunks = 4